import { render, staticRenderFns } from "./newHomeNavi.vue?vue&type=template&id=1c4423eb&scoped=true"
import script from "./newHomeNavi.vue?vue&type=script&lang=js"
export * from "./newHomeNavi.vue?vue&type=script&lang=js"
import style0 from "./newHomeNavi.vue?vue&type=style&index=0&id=1c4423eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4423eb",
  null
  
)

export default component.exports